export default __webpack_public_path__ + "static/media/home-digital-agency-img-02.8e488ce6.jpg";